// Cruise-type-specific package data, sourced from magiccruises.com.au live data
// Used by /app/frontend/src/components/EventPackagesSection.jsx

const SHARED_ENTERTAINMENT = [
 { label: "DJ", price: "$550", Icon: "Music" },
 { label: "Photographer", price: "$650", Icon: "Camera" },
 { label: "Magicians", price: "$1,800", Icon: "Sparkles" },
 { label: "Jet boat rides", price: "$1,850", Icon: "Anchor" },
 { label: "Clay pigeon shooting", price: "$1,550", Icon: "Star" }];

const SHARED_FAQS = [
 { q: "How does boarding work?", a: "Boarding is from King Street Wharf, Darling Harbour. We greet every guest, run safety briefings discreetly, and the boat departs to your scheduled time. Wharf fees are $55 per city wharf." },
 { q: "Can we customise the package?", a: "Every charter is custom. Swap canapés for buffet, add a beverage package, layer entertainment, change timings. Send us your brief and we'll build a quote that fits your night." },
 { q: "Can you cater for dietary requirements?", a: "Yes, vegetarian, gluten-free, halal, kosher, nut allergies and most other dietary requirements can be accommodated. Just flag them at the time of booking." },
 { q: "Is there a public holiday surcharge?", a: "Yes, a +20% surcharge applies to total bookings on public holidays, with a 4-hour minimum charter." }];

export const EVENT_PACKAGES = {
 // ───────────── BIRTHDAY ─────────────
 birthday: {
  title: "Birthday Cruise Packages",
  intro: "Sydney's best birthday cruise charters on the MV Sydney Magic. 18ths, 21sts, 30ths, 40ths, 50ths and 60ths, top-deck dance floor, full bar, DJ-ready sound, custom styling and Sydney Harbour as your backdrop.",
  accent: "fuchsia",
  photo: "https://customer-assets.emergentagent.com/job_magic-harbour-party/artifacts/n2oh3ova_birthday-cruises-sydney-harbour-magi.jpg",
  photoAlt: "Birthday cruise on Sydney Harbour · 16th birthday styling with Happy Birthday balloon arch and marquee numbers on board the Magic",
  packages: [
   {
    name: "Birthday Canapé Package",
    price: "$4,000",
    sub: "Up to 30 guests · 4 hour cruise",
    extras: "Additional guests at $75 per person · Max 100 cocktail style",
    inclusions: [
     "4-hour Sydney Harbour cruise", "Selection of 7 canapés · hot & cold", "Beverage package, wine, sparkling, beer, soft drinks", "Onboard licensed bar for spirits & cocktails", "Top-deck dance floor & built-in sound system", "Birthday signage placement · cake table set up"],
    menuTitle: "Birthday Canapé Menu",
    menu: {
     "Cold": [
      "Smoked salmon blinis with dill cream fraiche", "Hand-rolled sushi & nori with wasabi (veg/gf)"],"Hot": [
      "Gourmet party pies, beef burgundy & chicken leek", "Vegetarian spring rolls with sweet chilli (veg)", "Spicy Thai fish cakes with sweet chilli", "Beef koftas with tzatziki (gf)", "Seasoned potato wedges with sour cream & sweet chilli (veg/gf)"],
    },
    featured: true,
   },
   {
    name: "Birthday Buffet Package",
    price: "$5,500",
    sub: "Up to 30 guests · 4 hour cruise",
    extras: "Additional guests at $95 per person · Max 40 seated",
    inclusions: [
     "4-hour Sydney Harbour cruise", "Standing or seated buffet menu", "Beverage package, wine, sparkling, beer, soft drinks", "Onboard licensed bar for spirits & cocktails", "Top-deck dance floor & built-in sound system", "Birthday signage placement · cake table set up"],
    menuTitle: "Birthday Buffet Menu",
    menu: {
     "Starter": [
      "Vegetarian spring rolls with sweet chilli (veg)", "Spicy Thai fish cakes with sweet chilli"],"From the buffet": [
      "Oven-roasted BBQ chicken breast with herbed lemon glaze", "Whole King prawns with lemons & Mary Rose mayo", "Italian pasta salad, penne, cherry tomato, kalamata", "Classic potato salad with bacon", "Fresh garden salad with French dressing", "Artisan bakery rolls & butter"],"Cake table": ["Bring your own birthday cake, we provide the table, plates, napkins & cutting setup"],
    },
   }],
  faqs: [
   { q: "Can we decorate the boat?", a: "Yes, bring balloon installs, marquee numbers, photo backdrops, themed décor. The crew helps with setup before guests board. Most stylists know the Magic." },
   { q: "Is there a DJ included?", a: "DJ is an add-on at $550. Or use our built-in sound system + Spotify hookup to run your own playlist." },
   { q: "Can we bring a birthday cake?", a: "Always. We set up a cake table with plates, napkins and cutlery. Just let us know if you want it brought out at a specific moment." },
   { q: "Is there an age limit?", a: "Min age 18 unless the booking is a family birthday with under-18s supervised by parents. We're licensed and security may board for 18th/21st events." },...SHARED_FAQS],
 },

 // ───────────── WEDDING ─────────────
 wedding: {
  title: "Wedding Cruise Packages",
  photo: "https://customer-assets.emergentagent.com/job_magic-harbour-party/artifacts/lxhmsk0b_sydney%20cruises%20boats.png",
  photoAlt: "Wedding cruise on Sydney Harbour · bride and bridesmaids celebrating with champagne in front of the Opera House and Bridge",
  intro: "Specifically tailored Sydney Harbour wedding packages with seated buffet, beverage package, fully skirted bridal & wedding cake tables, chair covers and a wedding ribbon on the Magic. Ceremony on the top deck, reception below.",
  accent: "rose",
  packages: [
   {
    name: "Wedding Formal Package",
    price: "$6,500",
    sub: "Up to 30 guests · 4 hour cruise",
    extras: "Additional guests at $110 per person (max 42)",
    inclusions: [
     "4-hour Sydney Harbour cruise", "2 gourmet canapés + champagne on arrival", "Seated buffet menu", "Beverage package, wine, sparkling, beer, soft drinks", "Fully skirted bridal table", "Fully skirted wedding cake table", "White or black chair covers with sash", "Wedding ribbon, front of Magic"],
    menuTitle: "Seated Wedding Buffet",
    menu: {
     "Starters": [
      "Spicy Thai fish cakes with sweet chilli sauce", "Vegetarian spring rolls (oven baked) with sweet chilli sauce"],"Mains (Buffet)": [
      "Whole Tiger Prawns, fresh, served with lemons & Mary Rose mayo", "Oven roasted Chicken Breast, thyme infused BBQ Provencale, herbed lemon glaze", "Half Shell NZ Mussels, lemongrass & coconut curry, topped with coriander", "Italian Pasta Salad, penne, cherry tomato, kalamata olive, buffalo mozzarella", "Classic Potato Salad, sour cream & chive, crispy bacon bits", "Fresh Garden Salad, mixed leaf, French dressing, capsicum, carrot, onion, tomato", "Selection of artisan bakery rolls with individual butter portions"],"Dessert": [
      "Fresh seasonal fruit platter with maple cream sauce"],
    },
    featured: true,
   },
   {
    name: "Wedding Casual Package",
    price: "$5,700",
    sub: "Up to 30 guests · 4 hour cruise",
    extras: "Additional guests at $75 per person (max 85)",
    inclusions: [
     "4-hour Sydney Harbour cruise", "7-item canapé menu", "Beverage package, wine, sparkling, beer, soft drinks", "Fully skirted wedding cake table", "Wedding ribbon, front of Magic"],
    rules: [
     "Non-formal seated event, canapé/cocktail style"],
    menuTitle: "7-Item Canapé Menu",
    menu: {
     "Cold Canapés": [
      "Assorted sushi, hand-rolled with vegetarian options, wasabi & soy (gf, veg)", "Zucchini corn fritters, homemade, crispy, with crème fraîche (gf, veg)"],"Hot Canapés": [
      "Spicy Thai fish cakes with sweet chilli sauce", "Beef Koftas, fresh herbs, onion, garlic, traditional tzatziki (gf)", "Homemade Mini Quiche, roast pumpkin & feta with fresh dill (veg)", "Gourmet party pies, beef burgundy + chicken & leek", "Vegetarian spring rolls, oven baked, sweet chilli sauce (veg)"],
    },
   }],
  faqs: [
   { q: "Can we hold the ceremony on board?", a: "Yes, the top deck of the Magic is the perfect setting for your ceremony, then move below for reception, dinner and DJ." },
   { q: "How many guests can the boat accommodate?", a: "Up to 40 seated, or 120 cocktail-style. Wedding packages include 30 guests and additional guests are $100-$110 per person." },
   { q: "Can we bring our own celebrant / photographer / florist?", a: "Absolutely. You can bring your own suppliers or we can organise wedding DJ, photographer, flowers and styling for you." },...SHARED_FAQS],
 },

 // ───────────── CORPORATE ─────────────
 corporate: {
  title: "Corporate Cruise Packages",
  photo: "https://customer-assets.emergentagent.com/job_magic-harbour-party/artifacts/4rj1pv3y_corporate%20cruises%20sydney%20harbour.png",
  photoAlt: "Corporate cruise on Sydney Harbour · networking event in the saloon · suits with champagne and Opera House through panoramic windows",
  intro: "Private corporate harbour charters for EOFY parties, product launches, client entertainment, networking and team celebrations. 3-hour exclusive vessel hire from $4,000.",
  accent: "blue",
  packages: [
   {
    name: "Corporate Package 1, Canapé",
    price: "$4,000",
    sub: "Up to 30 guests · 3 hour private hire",
    extras: "Additional guests over 30 at $75 per person",
    inclusions: [
     "3-hour private vessel hire", "Selection of canapés served", "Beverage via bar tab or individual purchase", "Wharf fees and staff fees included", "Private exclusive use of the whole boat"],
    menuTitle: "Canapé Selection",
    menu: {
     "Cold": [
      "Smoked salmon blinis with dill cream fraiche", "Zucchini corn fritters with cream fraiche (veg / gf)"],"Hot": [
      "Gourmet party pies, beef burgundy and chicken & leek", "Vegetarian spring rolls with sweet chilli (veg)", "Spicy Thai fish cakes with sweet chilli"],
    },
    featured: true,
   },
   {
    name: "Corporate Package 2, Standing Buffet",
    price: "$4,800",
    sub: "Up to 30 guests · 3 hour private hire",
    extras: "Additional guests over 30 at $85 per person",
    inclusions: [
     "3-hour private vessel hire", "Standing buffet menu", "Beverage via bar tab or individual purchase", "Wharf fees and staff fees included", "Private exclusive use of the whole boat"],
    menuTitle: "Standing Buffet Menu",
    menu: {
     "Canapé start": [
      "Hand-rolled assorted sushi & nori (veg/gf)", "Gourmet party pies, beef burgundy and chicken & leek"],"Main buffet": [
      "Oven-roasted BBQ Provencale chicken breast", "Italian pasta salad", "Classic potato salad with bacon", "Fresh garden salad with French dressing", "Artisan bakery rolls & butter portions"],
    },
   }],
  faqs: [
   { q: "Can we brand the boat for our event?", a: "Yes, we welcome co-branded signage, pop-up banners, table décor and themed setups. Anything non-permanent works. Just bring your supplier in or we can organise stylists." },
   { q: "Is the venue suitable for client presentations?", a: "The saloon has a built-in sound system, mic-ready setup, and works well for keynote moments, awards or panel discussions. Speak to us about AV upgrades." },
   { q: "Can we run a tab or pre-pay drinks?", a: "Both, bar tab is paid at the end of the event, or you can pre-pay a fixed amount and switch to cash bar once spent." },...SHARED_FAQS],
 },

 // ───────────── CHRISTMAS ─────────────
 christmas: {
  title: "Christmas Cruise Packages",
  photo: "https://customer-assets.emergentagent.com/job_magic-harbour-party/artifacts/zjls6y8t_birthday-cruise-sydney-harbour.jpg",
  photoAlt: "Office Christmas party cruise on Sydney Harbour · group celebrating with gold festive balloons and decorations on the Magic",
  intro: "Office Christmas parties and family Christmas cruises on Sydney Harbour. Festive food, full beverage package, decorations included. Day cruise from 12pm or night cruise from 6pm.",
  accent: "emerald",
  packages: [
   {
    name: "Christmas Package 1, Canapé",
    price: "$5,900",
    sub: "Up to 30 guests · 4 hour vessel hire",
    extras: "Additional guests $75 per person",
    inclusions: [
     "4-hour vessel hire", "Canapé menu, 7 items", "Beverage package, wine, sparkling, beer & soft drinks", "Wharf fees, staff fees & Christmas decorations", "Day cruise from 12pm, night cruise from 6pm"],
    menuTitle: "Canapé Christmas Menu (7 items)",
    menu: {
     "Cold": [
      "Assorted sushi & nori rolls with wasabi & soy (veg/gf)", "Zucchini corn fritters with cream fraiche (veg/gf)"],"Hot": [
      "Gourmet party pies, beef burgundy and chicken & leek", "Homemade mini quiche with roast pumpkin, feta & dill (veg)", "Vegetarian spring rolls with sweet chilli (veg)", "Beef koftas with tzatziki (gf)", "Seasoned potato wedges with sour cream & sweet chilli (veg/gf)"],
    },
    beverage: ["Wolf Blass Eaglehawk Sauv Blanc", "Wolf Blass Eaglehawk Cab Sauv", "Wolf Blass Eaglehawk Cuvee", "Carlton Dry / Great Northern / Cascade Light", "Coca-Cola, soft drinks, fresh juice"],
    featured: true,
   },
   {
    name: "Christmas Package 2, Buffet",
    price: "$6,300",
    sub: "Up to 30 guests · 4 hour vessel hire",
    extras: "Additional guests $95 per person (up to 40 seated or 85 standing)",
    inclusions: [
     "4-hour vessel hire", "Full buffet menu", "Beverage package, wine, sparkling, beer & soft drinks", "Wharf fees, staff fees & Christmas decorations", "Day cruise from 12pm, night cruise from 6pm"],
    menuTitle: "Buffet Christmas Menu",
    menu: {
     "Starter": [
      "Vegetarian spring rolls with sweet chilli (veg)", "Spicy Thai fish cakes with sweet chilli"],"From the buffet": [
      "Oven-roasted BBQ chicken breast with herbed lemon glaze", "Italian pasta salad, penne, cherry tomato, kalamata, mozzarella", "Classic sour-cream & chive potato salad with bacon", "Fresh garden salad with French dressing", "Selection of bakery rolls & butter"],
    },
    beverage: ["Wolf Blass Eaglehawk Sauv Blanc", "Wolf Blass Eaglehawk Cab Sauv", "Wolf Blass Eaglehawk Cuvee", "Carlton Dry / Great Northern / Cascade Light", "Coca-Cola, soft drinks, fresh juice"],
   }],
  faqs: [
   { q: "Do you handle Christmas decorations?", a: "Yes, Christmas decorations are included in every Christmas package. Tree, garlands, tinsel, lights and table centrepieces all set up before boarding." },
   { q: "Can we do a day or night cruise?", a: "Both. Day cruises start from 12pm, great for office lunch parties. Night cruises start from 6pm and run into the evening with city lights across the harbour." },
   { q: "Are spirits included?", a: "The beverage package covers wine, sparkling, beer and soft drinks. Spirits are available via bar tab or individual purchase on board." },...SHARED_FAQS],
 },

 // ───────────── BYO ─────────────
 byo: {
  title: "BYO Cruise Packages",
  photo: "https://customer-assets.emergentagent.com/job_magic-harbour-party/artifacts/x11ti9s4_magic-sydney-harbour-cruise.jpg",
  photoAlt: "BYO cruise on Sydney Harbour · group enjoying private boat hire with their own drinks and Darling Harbour skyline",
  intro: "Magic is one of Sydney's only major BYO charter boats. Bring your own food and drinks (or food only) and save on catering, perfect for tighter budgets, dietary control or themed catering you supply yourself.",
  accent: "rose",
  packages: [
   {
    name: "BYO Package 1, Food & Drinks",
    price: "$3,600",
    priceNote: "Jan to Oct · $4,400 Nov to Dec",
    sub: "Up to 50 guests · 3.5 hour vessel hire",
    extras: "Boarding times to be confirmed · King St Wharf",
    inclusions: [
     "3.5-hour vessel hire", "Wharf fees & staff fees", "BYO food surcharge", "BYO drinks surcharge", "BYO disposable cutlery & plates", "BYO ice"],
    rules: [
     "Beverages must be arranged as one delivery prior to event (no individual BYO)", "BYO spirits and mixed spirit drinks permitted, conditions apply", "Sufficient food required", "Easy serviceable foods recommended (platter foods)"],
    featured: true,
   },
   {
    name: "BYO Package 2, Food Only",
    price: "$2,800",
    priceNote: "Feb to Oct · $3,900 Nov to Jan",
    sub: "Up to 75 guests · 3.5 hour vessel hire",
    extras: "BYO FOOD ONLY · drinks via bar",
    inclusions: [
     "3.5-hour vessel hire", "Wharf fees", "BYO food surcharge", "Built-in sound system"],
    rules: [
     "Drinks via individual purchase (cash bar) or pre-paid bar tab", "Bar tab requires 1 bar staff ($275) · min $1,000 bar spend", "Beverage package not available with this offer", "Guests take rubbish off at end (or $200 disposal fee)", "No 21 years or under · no bucks or hens cruises"],
   }],
  faqs: [
   { q: "Can we BYO any drinks?", a: "Package 1 yes, beer, wine, spirits, mixers. Package 2 is BYO FOOD ONLY and drinks must be purchased through our onboard bar (individual purchase or bar tab)." },
   { q: "Is there a corkage fee?", a: "No corkage on BYO Package 1, the price already includes the BYO surcharge. You bring it, we chill and serve it." },
   { q: "Do you provide bar staff?", a: "Package 1 includes bar staff. Package 2 requires 1 bar staff at $275 if running a bar tab." },
   { q: "Why no bucks/hens on BYO?", a: "Larger drinking-focused groups on BYO can be hard to manage. For hens & bucks we recommend the standard packages with our licensed bar and security included." },...SHARED_FAQS],
 },
};

export const ENTERTAINMENT_ADDONS = SHARED_ENTERTAINMENT;
